// import React from "react";
// import IMG from "../../Assests/logo.png";
// import "./new_footer.css";
// import Image from "../Image";

// import InstagramSVG from "../../Assests/Symbol Alternative.svg.png";
// import FacebookSVG from "../../Assests/Symbol.svg (1).png";
// import YoutubeSVG from "../../Assests/g10.png";
// import LinkedinSVG from "../../Assests/Symbol.svg.png";

// const socialIcons = {
//   INSTAGRAM: <img src={InstagramSVG} alt="Instagram" width={18} height={16} />,
//   FACEBOOK: <img src={FacebookSVG} alt="Facebook" width={18} height={16} />,
//   YOUTUBE: <img src={YoutubeSVG} alt="Youtube" width={18} height={16} />,
//   "LINKED-IN": <img src={LinkedinSVG} alt="LinkedIn" width={18} height={16} />,
// };

// const Footer = () => {
//   return (
//     <footer className="web-footer">
//       <div className="footer-inner">
//         {[
//           {
//             title: "SHOP",
//             links: [{ label: "Global Store", url: "/global-store" }, "B2b Store", "B2b Portal", "Brand", "Seller"],
//},
//           {
//             title: "ASSISTANCE",
//             links: [
//               "DELIVERY",
//               "PAYMENT",
//               "SHIPPING & RETURNS",
//               "TERMS & CONDITIONS",
//             ],
//           },
//           {
//             title: "HELP",
//             links: [
//               "Write To Us",
//               "Faq Tabs",
//               "Legal & Services",
//               // "COOKIES NOTICE",

//             ],
//           },
//           // {
//           //   title: "SOCIAL",
//           //   links: ["INSTAGRAM", "FACEBOOK", "YOUTUBE", "LINKED-IN"],
//           // },
//         ].map((section, index) => (
//           <div key={index} className="footer-section">
//             <h4>{section.title}</h4>
//             <ul
//               style={{
//                 listStyle: "none",
//                 padding: "0",
//                 lineHeight: "2",
//                 fontSize: "14px",
//               }}
//             >
//               {section.links.map((link, i) => (
//                 <li
//                   key={i}
//                   className="footer-link"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: "8px",
//                   }}
//                 >
//                   {section.title === "SOCIAL" && socialIcons[link]} {link}
//                 </li>
//               ))}
//             </ul>
//           </div>
//         ))}
//       </div>

//       <div className="web-footer-bottom">
//         <p
//           style={{
//             fontFamily: "Inter, sans-serif",
//             fontWeight: 400,
//             fontSize: "14px",
//             color: "#000000",
//             padding: "12px",
//             marginBottom: "10px",
//           }}
//         >
//           The Content Of This Site Is Copyright-Protected And Is The Property Of
//           Pentagon Tapes Pvt Ltd.
//         </p>

//         <Image
//           src={IMG}
//           alt="Logo"
//           style={{
//             width: "160px",
//             height: "auto",
//             marginTop: "15px",
//             maxWidth: "100%",
//             objectFit: "contain",
//           }}
//         />
//       </div>
//     </footer>
//   );
// };

// export default Footer;

import React from "react";
import IMG from "../../Assests/logo.png";
import "./new_footer.css";
import Image from "../Image";

// import InstagramSVG from "../../Assests/Symbol Alternative.svg.png";
// import FacebookSVG from "../../Assests/Symbol.svg (1).png";
// import YoutubeSVG from "../../Assests/g10.png";
// import LinkedinSVG from "../../Assests/Symbol.svg.png";
// import { Label } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

// const socialIcons = {
//   INSTAGRAM: <img src={InstagramSVG} alt="Instagram" width={18} height={16} />,
//   FACEBOOK: <img src={FacebookSVG} alt="Facebook" width={18} height={16} />,
//   YOUTUBE: <img src={YoutubeSVG} alt="Youtube" width={18} height={16} />,
//   "LINKED-IN": <img src={LinkedinSVG} alt="LinkedIn" width={18} height={16} />,
// };

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="web-footer">
      <div className="footer-inner" style={{ justifyContent: "space-between" }}>
        {[
          {
            title: "SHOP",
            links: [
              { label: "GLOBAL STORE", url: "/global_store" },
              { label: "B2B STORE", url: "/b2b_store" },
              { label: "B2B PORTAL", url: "/setting" },
              { label: "BRAND", url: "/Brand" },
              // { label: "SELLER", url: "/seller" },
            ],
          },
          {
            title: "QUICK LINKS",
            links: [
              { label: "MY ORDERS", url: "/your_order" },
              { label: "WISHLIST", url: "/wishlist" },
              { label: "PROFILE", url: "/profile" },
              { label: "ADDRESS", url: "/my_address" },
            ],
          },
          {
            title: "HELP",
            links: [
              { label: "WRITE TO US", url: "/help_center?open=write" },
              { label: "FAQ", url: "/help_center?open=faq" },
              //  { label: "LegalServices", url: "/help_center?open=cancel" },
              { label: "LEGAL SERVICES", url: "/help_center?open=legal" },

              // {label:"Faq", url:""}
              //  {label:"FAQ TABS", url:"/help_center"}

              // "COOKIES NOTICE",
            ],
          },
        ].map((section, index) => (
          <div key={index} className="footer-section">
            <h4 style={{ fontSize: "22px" }}>{section.title}</h4>
            <ul
              style={{
                listStyle: "none",
                padding: "0",
                lineHeight: "2",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              {section.links.map((link, i) => (
                <li
                  key={i}
                  className="footer-link hover:underline underline-offset-4"
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {typeof link === "object" && link.url ? (
                    <div
                      onClick={() => navigate(link.url)}
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {link.label}
                    </div>
                  ) : (
                    link
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="web-footer-bottom">
        <p
          style={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 400,
            fontSize: "14px",
            // color: "#000000",
            padding: "12px",
            // marginBottom: "10px",
          }}
        >
          The Content Of This Site Is Copyright-Protected And Is The Property Of
          Pentagon Tapes Pvt Ltd.
        </p>

        {/* <div>
          <Image
            src={IMG}
            alt="Logo"
            style={{
              width: "160px",
              height: "auto",
              marginTop: "15px",
              maxWidth: "100%",
              objectFit: "contain",
            }}
            className={"bg-white"}
          />
        </div> */}
      </div>
    </footer>
  );
};

export default Footer;
